var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.value.title,
      "alerts": _vm.alerts,
      "breadCrumbs": _vm.breadCrumbs,
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    }
  }), _c('v-tabs', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.positions")))]), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentDetail.pdf")))])], 1), _c('v-divider'), _c('m-detail-view-grid', {
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('select-assignees', {
          attrs: {
            "css": "width: 100%",
            "partnerId": _vm.partner.id,
            "outlined": true,
            "dense": false
          },
          on: {
            "input": _vm.onAssigneesUpdate,
            "added": _vm.onAssigneesAdded,
            "removed": _vm.onAssigneesRemoved
          },
          model: {
            value: _vm.value.assignees,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "assignees", $$v);
            },
            expression: "value.assignees"
          }
        }), _c('shared-content-list', {
          ref: "sharedContentList",
          attrs: {
            "refId": _vm.value.id,
            "partnerId": _vm.value.partnerId,
            "title": _vm.$t('clearanceApproval.shared')
          },
          on: {
            "update:sharedContent": _vm.onSharedContentUpdate
          }
        }), _vm.value.seller && _vm.value.seller.ref ? _c('div', [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.seller")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.seller,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.seller.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.seller.ref && _vm.value.seller.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.seller.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm._e(), _vm.value.buyer && _vm.value.buyer.ref ? _c('div', [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.buyer")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.buyer,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.buyer.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.buyer.ref && _vm.value.buyer.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.buyer.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm._e(), _c('div', {
          staticClass: "mt-4"
        }), !_vm.value.isCompleted || _vm.value.estimateId ? _c('select-entity', {
          staticClass: "mt-2 mb-2",
          attrs: {
            "refType": _vm.ResourceEnum.REPAIR_ESTIMATE,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.clearanceApproval.estimateId'),
            "hint": _vm.$t('objects.clearanceApproval.estimateIdHint'),
            "clearable": !_vm.value.isCompleted,
            "disabled": _vm.value.isCompleted
          },
          on: {
            "input": function input($event) {
              return _vm.value.updatePartial({
                estimateId: $event || null
              });
            }
          },
          model: {
            value: _vm.value.estimateId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "estimateId", $$v);
            },
            expression: "value.estimateId"
          }
        }) : _vm._e(), !_vm.value.isCompleted || _vm.value.reportId ? _c('select-entity', {
          staticClass: "mt-2 mb-n2",
          attrs: {
            "refType": _vm.ResourceEnum.REPORT,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.repairEstimate.reportId'),
            "hint": _vm.$t('objects.repairEstimate.reportIdHint'),
            "clearable": !_vm.value.isCompleted,
            "disabled": _vm.value.isCompleted
          },
          on: {
            "input": function input($event) {
              return _vm.value.updatePartial({
                reportId: $event || null
              });
            }
          },
          model: {
            value: _vm.value.reportId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "reportId", $$v);
            },
            expression: "value.reportId"
          }
        }) : _vm._e(), _vm.value.report && _vm.value.report.vehicle ? _c('div', {
          staticClass: "mt-n8"
        }, [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("common.nouns.vehicle")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-vehicle', {
          key: _vm.value.report.vehicleId + 'refs-report-clearance-approval',
          attrs: {
            "item": _vm.value.report.vehicle
          },
          on: {
            "openDetail": function openDetail($event) {
              _vm.value.report.vehicle.goTo(_vm.$router).detail();
            }
          },
          scopedSlots: _vm._u([{
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.ResourceEnum.VEHICLE).icon) + " ")])];
            },
            proxy: true
          }], null, false, 1337751523)
        })], 1)], 1) : _vm._e(), _vm.refsCategories.length ? _c('div', [_c('v-subheader', {
          staticClass: "mt-2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.clearanceApproval.refs")) + " ")]), _c('refs-select', {
          ref: "refsSelect",
          attrs: {
            "partnerId": _vm.value.partnerId,
            "loading": _vm.isLoadingRefs,
            "suggested": [],
            "listMode": false,
            "hideEditButton": false,
            "categories": _vm.refsCategories,
            "hideSuggestions": true,
            "confirmable": false
          },
          on: {
            "confirm": _vm.saveRefs,
            "change": _vm.saveRefs,
            "input": _vm.saveRefs
          },
          model: {
            value: _vm.value.refs,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "refs", $$v);
            },
            expression: "value.refs"
          }
        })], 1) : _vm._e(), _c('v-divider', {
          staticClass: "mt-6"
        }), _c('m-action-list', {
          attrs: {
            "actions": _vm.bottomActions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('clearance-approval-detail-form', {
    attrs: {
      "value": _vm.value
    }
  }), _c('activity-card', {
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: false
      }
    }
  })], 1), _c('v-tab-item', [_vm.isDocumentLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : _vm.document ? _c('iframe', {
    staticClass: "pdf",
    staticStyle: {
      "height": "calc(100vh - 220px)",
      "width": "100%"
    },
    attrs: {
      "title": "pdf",
      "src": _vm.document.url
    }
  }) : _c('clearance-approval-detail-add-response', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onResponseAdded
    }
  })], 1)], 1)], 1), _vm.isDeleteDialogActive && _vm.value ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }) : _vm._e(), _c('clearance-approval-create-clearance-dialog', {
    ref: "clearanceApprovalCreateClearanceDialog",
    attrs: {
      "clearanceApprovals": [_vm.value],
      "repairEstimate": _vm.repairEstimate,
      "partnerId": _vm.value.partnerId,
      "hideButton": true,
      "report": _vm.value.report
    }
  }), _c('clearance-approval-create-request-dialog', {
    ref: "clearanceApprovalCreateRequestDialog",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "hideButton": true,
      "report": _vm.value.report,
      "clearance": _vm.value
    },
    on: {
      "create:sharedContent": function createSharedContent($event) {
        return _vm.sharedContent.push($event);
      }
    }
  }), _c('clearance-approval-change-expiration-dialog', {
    ref: "clearanceApprovalChangeExpirationDialog",
    attrs: {
      "value": _vm.value
    }
  }), _vm.personSideCard ? _c('person-side-card', {
    attrs: {
      "value": _vm.personSideCard
    },
    on: {
      "close": function close($event) {
        _vm.personSideCard = null;
      }
    }
  }) : _vm._e(), _vm.companySideCard ? _c('company-side-card', {
    attrs: {
      "value": _vm.companySideCard
    },
    on: {
      "close": function close($event) {
        _vm.companySideCard = null;
      }
    }
  }) : _vm._e(), _c('template-dialog', {
    ref: "replyToInformationRequestDialog",
    attrs: {
      "hideButton": true,
      "from": [_vm.partner],
      "to": _vm.to,
      "refs": [{
        refId: _vm.value.id,
        refType: _vm.ResourceEnum.CLEARANCE_APPROVAL
      }],
      "context": {
        clearanceApproval: _vm.value
      }
    },
    on: {
      "sent": _vm.resetStateBackToRequested
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isFinishDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('clearanceApproval.response.finish'),
      "subtitle": _vm.$t('clearanceApproval.response.finishSubtitle'),
      "loading": _vm.isFinishLoading,
      "rightLoading": _vm.isFinishLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isFinishDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isFinishDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isFinishDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isFinishDialogActive = false;
      },
      "rightClick": _vm.finishRequest
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }